module.exports = __webpack_public_path__ + "fonts/Barlow-Regular.42bceb00.eot";